/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAdvancePassengerInformationRequest } from '../../models/finnair-advance-passenger-information-request';

export interface UpdateAdvancePassengerInformation$Params {
  orderId: string;
  hash?: string;
  locale?: string;
      body: Array<FinnairAdvancePassengerInformationRequest>
}

export function updateAdvancePassengerInformation(http: HttpClient, rootUrl: string, params: UpdateAdvancePassengerInformation$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, updateAdvancePassengerInformation.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.query('locale', params.locale, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

updateAdvancePassengerInformation.PATH = '/api/v2/order/{orderId}/advance-passenger-information';
